<p-toast />
<div class="layout-topbar">
  <div class="layout-topbar-logo-container">
    <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
      <i class="pi pi-bars"></i>
    </button>
    <a class="layout-topbar-logo" routerLink="/">
      <img
        [src]="'assets/images/logo' + (layoutService.isDarkTheme() ? '-dark' : '-light') + '.svg'"
        alt="logo"
        class="w-36 h-36"
      />
    </a>
  </div>

  @if (authService.sessionWarning() === 'critical') {
  <div
    class="flex gap-1.5 items-center px-4 py-1.5 text-sm font-medium animate-banner-slide-in motion-reduce:animate-none rounded-md bg-surface-100 dark:bg-surface-800 text-surface-900 dark:text-surface-0"
  >
    <i
      class="text-sm pi pi-exclamation-triangle shrink-0 animate-icon-pulse motion-reduce:animate-none"
    ></i>
    <span>👋 Hey! We're kicking you out in</span>
    <span
      class="font-bold tabular-nums tracking-wide animate-countdown-tick motion-reduce:animate-none"
      >{{ authService.expiryCountdown() }}</span
    >
    <span>— whatever happens next is on you, not us 👀</span>
  </div>
  }

  <div class="layout-topbar-actions">
    <div class="layout-config-menu">
      <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
        <i [class]="layoutService.isDarkTheme() ? 'pi pi-moon' : 'pi pi-sun'"></i>
      </button>
      <!-- <div class="relative">
        <button
          class="layout-topbar-action layout-topbar-action-highlight"
          pStyleClass="@next"
          enterFromClass="hidden"
          enterActiveClass="animate-scalein"
          leaveToClass="hidden"
          leaveActiveClass="animate-fadeout"
          [hideOnOutsideClick]="true"
        >
          <i class="pi pi-palette"></i>
        </button>
        <app-configurator />
      </div> -->
    </div>

    <!-- User Profile Section -->
    <div class="flex gap-2 items-center">
      <button class="layout-topbar-action" (click)="userPanel.toggle($event)" type="button">
        <i class="pi pi-user"></i>
      </button>

      <p-popover #userPanel>
        <div class="p-4 min-w-[200px]">
          <div class="pb-3 mb-3 border-b border-surface-border">
            <div class="mb-1 text-sm font-semibold text-surface-900 dark:text-surface-0">
              {{ authService.user()?.firstName || 'User' }}
            </div>
            <div class="text-xs text-surface-500 dark:text-surface-400">
              {{ authService.user()?.email || '' }}
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <button
              type="button"
              class="flex gap-2 items-center p-2 w-full text-left bg-transparent rounded-md border-none transition-colors duration-200 cursor-pointer text-surface-900 dark:text-surface-0 hover:bg-surface-100 dark:hover:bg-surface-800"
              (click)="onLogout(); userPanel.hide()"
            >
              <i class="text-sm pi pi-sign-out"></i>
              <span>Logout</span>
            </button>
          </div>
        </div>
      </p-popover>
    </div>
  </div>
</div>
